import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import Header from "../../component/common/Header";

const HeroSection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const context = gsap.context(() => {
      const textElements = gsap.utils.toArray(".animated-text-content");
      const imageElement = sectionRef.current.querySelector(".hero-image");

      // --- 1. Text Reveal Animation (Auto-Play) ---
      // Initial State: Hidden, down, and clipped
      gsap.set(textElements, {
        y: 50, // Slightly more distance for dramatic hero effect
        opacity: 0,
        clipPath: "inset(100% 0 0% 0)",
      });

      // Animation: Play immediately on load
      gsap.to(textElements, {
        y: 0,
        opacity: 1,
        clipPath: "inset(0% 0 0% 0)",
        duration: 1.2,
        ease: "power3.out",
        stagger: 0.2, // Title appears first, then paragraph
        delay: 0.2, // Small delay after page load
      });

      // --- 2. Image Animation (Subtle Scale Up) ---
      if (imageElement) {
        gsap.fromTo(
          imageElement,
          { scale: 0.95, opacity: 0 },
          {
            scale: 1,
            opacity: 1,
            duration: 1.5,
            ease: "power2.out",
            delay: 0.6, // Starts after text begins
          },
        );
      }
    }, sectionRef);

    return () => context.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="w-full bg-gradient-to-b  min-h-[130vh]   md:min-h-[1321px] from-[#ffffff4c] bg-[#CCE9FF] font-[Sora]"
      style={{
        backgroundImage: "url(/images/aboutBG.webp)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="relative w-full ">
        {/* Content Container */}
        <div className="relative z-20 w-full">
          <div className="w-full pt-[1px]">
            <Header />
          </div>

          {/* Hero Content */}
          <div className="flex flex-col gap-[10px] 2xl:gap-[20px] justify-start items-center w-full px-[28px] 2xl:px-[56px] mt-[40px] md:mt-[80px] 2xl:mt-[132px] max-w-[1612px] mx-auto">
            {/* Title Wrapper (overflow-hidden ensures the 'rise up' effect looks clean) */}
            <div className="overflow-hidden pb-2">
              {" "}
              {/* Added pb-2 to prevent clipping descenders like 'g' or 'p' */}
              <h1 className="text-[24px] sm:text-[30px] md:text-[45px] 2xl:text-[60px] font-bold leading-normal text-center text-text-primary max-w-full animated-text-content">
                Govardhannathji Energies LLP – Pioneering Sustainability in
                Agriculture & Energy
              </h1>
            </div>

            {/* Paragraph Wrapper */}
            <div className="overflow-hidden pb-2 w-full flex justify-center">
              <p className="text-[16px] 2xl:text-[24px] font-normal leading-lg text-center text-text-primary w-full animated-text-content ">
                At Govardhannathji Energies LLP, we are committed to
                revolutionizing agriculture and energy sectors with innovative
                and sustainable solutions. Our mission is to promote
                eco-friendly practices by offering high-quality organic
                fertilizers and bio gas energy solutions that enhance soil
                health, reduce carbon emissions, and support renewable energy
                initiatives.
              </p>
            </div>
          </div>

          {/* Bottom Image */}
          {/* <div className="flex flex-row justify-center items-center w-auto mt-[32px] overflow-hidden">
            <img
              src="/images/aboutImg/AboutHome.png"
              alt="Bio gas facility"
              className="w-full max-w-[959px] 2xl:max-w-[1918px] h-auto hero-image"
            />
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
